import { useContextEmpleado } from "../../contexto/empleado/EmpleadoContext";

const AlertaCreditosVencidos = () => {
    const { alertasCreditosVencidos = [] } = useContextEmpleado();

    if (alertasCreditosVencidos.length === 0) {
        return (
            <span className="dropdown-item text-center text-muted">
                No hay créditos vencidos
            </span>
        );
    }

    return (
        <>
            {alertasCreditosVencidos.map(({ title, subtitle, message, type, category }, index) => (
                <a
                    key={index}
                    href={category === "venta" ? "/app/admin/ventas/contraEntrega" : "/app/admin/compras/credito"}
                    className={`dropdown-item ${category === "venta" ? "text-warning" : "text-danger"}`}
                >
                    <i className={`fas fa-exclamation-triangle mr-2`} />
                    <strong>{title}</strong> — {subtitle}
                    <br />
                    {message}
                </a>
            ))}
        </>
    );
};

export default AlertaCreditosVencidos;
